// __EQUIP_ASSIGN__ (2026-10-04) Equipment Assignment view -> the database. Every change goes
// through public.equipment_assign(op) (sql/equipment_assignments.sql): office logins only, one
// audit_log row per change ('equipment_assignment'), and it keeps drivers.current_truck_id and
// truck_trailer_combinations.default_driver_id in step for the code that still reads them.
import { supabase } from '../supabaseClient';
import { invalidateEquipmentCache } from './equipmentService';

const FRIENDLY = [
  [/EQUIPMENT_ASSIGN_FORBIDDEN/, 'Only office logins can change equipment assignments.'],
  [/EQUIPMENT_ASSIGN_NOT_FOUND/, 'That driver or unit no longer exists - the view was refreshed.'],
  [/driver_equipment_assignments_one_primary/, 'A driver can have only one primary setup.'],
  [/function public\.equipment_assign|Could not find the function/, 'The equipment assignment database change is not installed yet.'],
];
export const friendlyError = (e) => {
  const m = String((e && (e.message || e.details)) || e || 'unknown error');
  const hit = FRIENDLY.find(([rx]) => rx.test(m));
  return hit ? hit[1] : m;
};

// ops: equipment_assign op objects (assign / unassign / set_primary / couple / uncouple /
// restore / batch). Several are sent as one batch so they succeed or fail together.
export async function runAssignOps(ops) {
  const list = (ops || []).filter(Boolean);
  if (!list.length) return { ok: true };
  const op = list.length === 1 ? list[0] : { op: 'batch', ops: list };
  const { data, error } = await supabase.rpc('equipment_assign', { p_op: op });
  invalidateEquipmentCache();
  if (error) throw new Error(friendlyError(error));
  return data || { ok: true };
}

// Drivers > Equipment (one pick per driver): the picked combination's truck becomes his primary
// setup (its trailer follows); '' clears his primary.
export async function setPrimaryTruck(driverId, truckId, currentPrimaryTruckId) {
  if (truckId) return runAssignOps([{ op: 'assign', driver_id: driverId, truck_id: truckId, primary: true }]);
  if (currentPrimaryTruckId) return runAssignOps([{ op: 'unassign', driver_id: driverId, truck_id: currentPrimaryTruckId }]);
  return { ok: true };
}
